import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var LoginQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query login($secret: String!) {\n    login(secret: $secret) {\n      token\n    }\n  }\n"])));
export default LoginQuery;